// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";
import { getCurrentUserIsGuest, getIsPunchOutSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import setShowInventory from "@insite/client-framework/Store/Context/Handlers/SetShowInventory";
import setShowPricing from "@insite/client-framework/Store/Context/Handlers/SetShowPricing";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
// import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors"; // Starter Custom Code
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import setIsReorderConfirmationModalOpen from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetIsReorderConfirmationModalOpen";
import setNextAction from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetNextAction";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
// import Eye from "@insite/mobius/Icons/Eye"; // Starter Custom Code
// import EyeOff from "@insite/mobius/Icons/EyeOff"; // Starter Custom Code
import User from "@insite/mobius/Icons/User";
import Menu, { MappedLink } from "@insite/mobius/Menu";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import React, { useEffect } from "react"; // Starter Custom Code
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

/* Starter Custom Code - Start */
import { Dictionary } from "@insite/client-framework/Common/Types";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import changeCustomerContext from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadCurrentBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadCurrentBillTo";
import {
    getCurrentPage,
    getLocation,
    getLocationPathAndQuery,
} from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadCurrentShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTo";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import FindLocationModal from "@insite/content-library/Components/FindLocationModal";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Popover, { PopoverPresentationProps } from "@insite/mobius/Popover";
import Radio from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import getColor from "@insite/mobius/utilities/getColor";
import constants from "@store/constants";
import AccountMessagesCount, {
    AccountMessagesCountPresentationProps,
} from "@store/Library/Components/Toolkit/AccountMessagesCount";
import HeaderLink, { HeaderLinkStyles } from "@store/Library/Components/Toolkit/HeaderLink";
import Eye from "@store/Library/Components/Toolkit/Icons/Eye/EyeLine";
import EyeOff from "@store/Library/Components/Toolkit/Icons/EyeOff/EyeOffLine";
import PersonFill, { PersonFillOffset } from "@store/Library/Components/Toolkit/Icons/Person/PersonFill";
import SideMenu, { SideMenuPresentationProps } from "@store/Library/Components/Toolkit/SideMenu";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@store/Overrides/Components/AddressInfoDisplay";
import { boxStyles } from "@store/Themes/common/mixins/box";
import { headerHideForMobileStyles } from "@store/Themes/common/mixins/header";
import { addressProps } from "@store/Themes/common/props/address";
import usePreviousExisting from "@toolkit/Framework/Common/Hooks/usePreviousExisting";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { IconMap } from "@toolkit/Framework/Types/Icon";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";

/* Store Custom Code - Start */
import { useIsB2BCustomer } from "@store/Framework/Store/Data/BillTos/BillTosHooks";
/* Store Custom Code - End */

const iconMap: Dictionary<IconMap> = {
    user: {
        src: PersonFill,
        offset: PersonFillOffset,
    },
};
/* Starter Custom Code - End */

const enum fields {
    visibilityState = "visibilityState",
    icon = "icon",
    includeAccountMenu = "includeAccountMenu",
    showPricingToggle = "showPricingToggle",
    showInventoryToggle = "showInventoryToggle",
}

const mapStateToProps = (state: ApplicationState) => {
    /* Starter Custom Code - Start */
    const { firstName, lastName, userName } = state.context.session;
    const settings = getSettingsCollection(state);
    const currentUserIsGuest = getCurrentUserIsGuest(state);
    /* Starter Custom Code - End */

    return {
        isSignInPage: getCurrentPage(state).type === "SignInPage",
        userName, // Starter Custom Code
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        currentUserIsGuest, // Starter Custom Code
        isPunchOutSession: getIsPunchOutSession(state),
        currentLocation: getLocation(state),
        displayChangeCustomerLink: state.context.session?.displayChangeCustomerLink || false,
        displayPricingAndInventory: state.context.session?.displayPricingAndInventory || false,
        showInventory: state.context.showInventory,
        showPricing: state.context.showPricing,
        isReorderConfirmationModalOpen: state.pages.vmiBins.isReorderConfirmationModalOpen,
        hasChangeLastQty:
            state.pages.vmiBins.selectVmiBinsChangedQty &&
            Object.keys(state.pages.vmiBins.selectVmiBinsChangedQty).length > 0,
        orderConfirmationPageUrl: getPageLinkByPageType(state, "OrderConfirmationPage")?.url,
        onePageCheckoutConfirmationPageUrl: getPageLinkByPageType(state, "OnePageCheckoutConfirmationPage")?.url,
        // Starter Custom Code
        isSignedIn: userName && !currentUserIsGuest,
        userDisplayName: firstName ? `${firstName}${lastName ? ` ${lastName}` : ""}` : userName,
        currentBillTo: getCurrentBillToState(state).value,
        currentShipTo: getCurrentShipToState(state).value,
        enableWarehousePickup: settings.accountSettings.enableWarehousePickup,
        fulfillmentMethod: state.context.session.fulfillmentMethod,
        pickUpWarehouse: state.context.session.pickUpWarehouse,
        isAuthenticated: state.context.session.isAuthenticated,
        returnUrl: getLocationPathAndQuery(state),
    };
};

const mapDispatchToProps = {
    signOut,
    cancelPunchOut,
    setSignInOverlayIsOpen,
    setShowInventory,
    setShowPricing,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    // Starter Custom Code
    loadCurrentBillTo,
    loadCurrentShipTo,
    changeCustomerContext,
};

export interface HeaderSignInStyles {
    signOutWrapper?: InjectableCss;
    titleClickable?: ClickablePresentationProps;
    titleIcon?: IconPresentationProps;
    titleTypography?: TypographyPresentationProps;
    signOutClickable?: ClickablePresentationProps;
    // Starter Custom Code
    headerLink?: HeaderLinkStyles;
    popover?: PopoverPresentationProps;
    sideMenu?: SideMenuPresentationProps;
    popoverGridContainer?: GridContainerProps;
    popoverMenuGridItem?: GridItemProps;
    popoverInfoGridItem?: GridItemProps;
    loadingOverlay?: LoadingOverlayProps;
    infoSection?: InjectableCss;
    infoGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoSubtitle?: TypographyPresentationProps;
    addressWrapper?: InjectableCss;
    addressName?: TypographyPresentationProps;
    address?: AddressInfoDisplayStyles;
    addressLink?: LinkPresentationProps;
    fulfillmentRadioGroup?: RadioGroupProps;
    accountMessagesCountStyles?: AccountMessagesCountPresentationProps;
}

export const headerSignInStyles: HeaderSignInStyles = {
    signOutWrapper: {
        css: headerHideForMobileStyles(),
    },
    popover: {
        wrapperProps: {
            css: css`
                ${breakpoint("sm", "down")} {
                    position: static;
                }
            `,
        },
        contentBodyProps: {
            css: css`
                ${boxStyles(null)}
                width: ${pxToRem(700)};
                max-height: none;
                color: ${getColor("text")};

                ${breakpoint("sm", "down")} {
                    max-width: 100%;
                }
            `,
        },
    },
    popoverGridContainer: { gap: 0 },
    popoverInfoGridItem: {
        width: [12, 8, 8, 8, 8],
        css: css`
            flex-direction: column;
            order: 2;
            font-size: ${x => x.theme.design.typography.size.smaller};
            background-color: ${getColor("common.background") /* Store Custom Code */};

            ${breakpoint("sm")} {
                order: 1;
            }
        `,
    },
    popoverMenuGridItem: {
        width: [12, 4, 4, 4, 4],
        css: css`
            /* Store Removed - border-bottom */
            order: 1;
            /* Store Custom Code - Start */
            background-color: ${getColor("common.accent")};
            /* Store Custom Code - End */

            ${breakpoint("sm")} {
                order: 2;
                /* Store Removed - border-bottom */
                /* Store Removed - border-left */
            }
        `,
    },
    infoGridContainer: {
        gap: 0,
        css: css`
            ${x => gridGapStyles(pxToRemArray([20]), [x.theme.design.typography.spacing.base])}
        `,
    },
    infoGridItem: {
        width: 6,
        css: css`
            flex-direction: column;
        `,
    },
    loadingOverlay: {
        css: css`
            height: 100%;
        `,
    },
    infoSection: {
        css: css`
            width: 100%;
            padding: ${pxToRem(22)};
            border-bottom: 1px solid ${getColor("common.border")};

            &:last-child {
                border-bottom: 0;
            }
        `,
    },
    infoSubtitle: addressProps.label,
    addressName: addressProps.name,
    addressLink: addressProps.link,
    fulfillmentRadioGroup: {
        sizeVariant: "small",
    },
    sideMenu: {
        overridedStyles: {
            wrapper: {
                css: css`
                    width: 100%;
                `,
            },
        },
    },
    accountMessagesCountStyles: { position: pxToRemArray([-5, null, null, 10]) }, // Store Custom Code
};

interface OwnProps extends WidgetProps {
    fields: {
        [fields.visibilityState]: string;
        [fields.icon]: string;
        [fields.includeAccountMenu]: boolean;
        [fields.showPricingToggle]: boolean;
        [fields.showInventoryToggle]: boolean;
    };
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory &
    ThemeProps<BaseTheme>;

let icon: React.ComponentType<IconPresentationProps>;

export const HeaderSignIn = ({
    userName,
    isSignInPage,
    currentUserIsGuest,
    signOut,
    cancelPunchOut,
    fields,
    history,
    myAccountPageLink,
    signInUrl,
    isPunchOutSession,
    currentLocation,
    displayChangeCustomerLink,
    displayPricingAndInventory,
    showInventory,
    showPricing,
    setSignInOverlayIsOpen,
    setShowInventory,
    setShowPricing,
    theme,
    isReorderConfirmationModalOpen,
    hasChangeLastQty,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    orderConfirmationPageUrl,
    onePageCheckoutConfirmationPageUrl,
    // Starter Custom Code
    isSignedIn,
    userDisplayName,
    currentBillTo,
    currentShipTo,
    enableWarehousePickup,
    fulfillmentMethod,
    pickUpWarehouse,
    loadCurrentBillTo,
    loadCurrentShipTo,
    changeCustomerContext,
    isAuthenticated,
    returnUrl,
}: Props) => {
    const styles = useMergeStyles("headerSignIn", headerSignInStyles);
    const isB2BCustomer = useIsB2BCustomer(); // Store Custom Code

    useEffect(() => {
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    }, [userName]);

    /* Starter Custom Code - Start */
    const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
    const [isLocationModalLoading, setIsLocationModalLoading] = useState(false);
    const [isInfoLoading, setIsInfoLoading] = useState(false);

    const lastBillTo = usePreviousExisting(currentBillTo);
    const lastShipTo = usePreviousExisting(currentShipTo);
    const billTo = currentBillTo || lastBillTo;
    const shipTo = currentShipTo || lastShipTo;

    const elementRef = useRef<HTMLUListElement>(null);
    const popoverRef = useRef<HTMLUListElement>(null);

    const showIconOnly = fields.visibilityState === "icon";

    useEffect(() => {
        if (isAuthenticated && isSignedIn) {
            if (!currentBillTo) {
                loadCurrentBillTo();
            }
            if (!currentShipTo) {
                loadCurrentShipTo();
            }
        }
    }, []);
    /* Starter Custom Code - End */

    if (!myAccountPageLink) {
        return null;
    }

    const { visibilityState, includeAccountMenu, showInventoryToggle, showPricingToggle } = fields;
    const showIcon = visibilityState === "both" || visibilityState === "icon";
    const showLabel = visibilityState === "both" || visibilityState === "label";

    const icon = iconMap[fields.icon]; // Starter Custom Code

    const currentMode = getCookie(NavigationModeCookieName);
    let menuItems = (myAccountPageLink?.children?.filter(
        pageLink => !(pageLink.type === "ChangeCustomerPage" && !displayChangeCustomerLink),
    ) ?? []) as MappedLink[];

    const getMenuItem = (title: "Inventory" | "Pricing"): MappedLink => {
        return {
            title: title === "Inventory" ? translate("Inventory") : translate("Pricing"),
            iconProps: {
                src: (title === "Inventory" && showInventory) || (title === "Pricing" && showPricing) ? EyeOff : Eye,
                size: 22,
                css: css`
                    margin-left: 20px;
                    margin-right: -12px;
                `,
            },
            clickableProps: {
                css: css`
                    display: flex;
                    text-transform: uppercase;
                `,
                onClick: () => {
                    title === "Inventory"
                        ? setShowInventory({ showInventory: !showInventory })
                        : setShowPricing({ showPricing: !showPricing });
                },
            },
        };
    };

    if (!currentMode || currentMode === "Storefront") {
        menuItems = menuItems?.filter(pageLink => pageLink.type !== "VmiUsersPage");

        // Starter Removed - showInventoryToggle
        // Starter Removed - showPricingToggle
    }

    const onSignInHandler = (e: React.MouseEvent) => {
        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            e.preventDefault();

            if (theme.signIn?.useOverlay) {
                setSignInOverlayIsOpen({ isOpen: true });
                return;
            }

            if (!signInUrl) {
                logger.warn("No url was found for SignInPage, defaulting to /SignIn");
                history.push("/MyAccount/SignIn");
                return;
            }

            const returnUrl = currentLocation.pathname + currentLocation.search;
            if (
                returnUrl === "/" ||
                (currentUserIsGuest && orderConfirmationPageUrl && returnUrl.indexOf(orderConfirmationPageUrl) > -1) ||
                (currentUserIsGuest &&
                    onePageCheckoutConfirmationPageUrl &&
                    returnUrl.indexOf(onePageCheckoutConfirmationPageUrl) > -1)
            ) {
                history.push(`${signInUrl}`);
                return;
            }

            history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`);
        }
    };

    const onSignOutHandler = () => {
        if (!isReorderConfirmationModalOpen && hasChangeLastQty) {
            setIsReorderConfirmationModalOpen({ isReorderConfirmationModalOpen: true });
            setNextAction({ nextAction: signOutFunc });
        } else {
            signOutFunc();
        }
    };

    const signOutFunc = () => {
        isPunchOutSession ? cancelPunchOut() : signOut();
    };

    let signInStatusText = translate("Sign In");
    if (userName && !currentUserIsGuest) {
        signInStatusText = userDisplayName; // Starter Custom Code
    }

    /* Starter Custom Code - Start */
    const closePopover = () => {
        popoverRef.current && (popoverRef.current! as any).closePopover();
    };

    const handleChangeFulfillmentMethod = async (event: ChangeEvent<HTMLInputElement>) => {
        setIsInfoLoading(true);
        await changeCustomerContext({
            fulfillmentMethod: event.currentTarget.value,
            pickUpWarehouse,
            // Starter Custom Code
            returnUrl,
        });
    };

    const changeWarehouse = () => {
        setIsLocationModalOpen(true);
        closePopover();
    };

    const selectWarehouse = async (pickUpWarehouse: WarehouseModel) => {
        setIsLocationModalLoading(true);
        await changeCustomerContext({
            fulfillmentMethod,
            pickUpWarehouse,
            // Starter Custom Code
            returnUrl,
        });
    };

    const closeLocationModal = () => setIsLocationModalOpen(false);
    /* Starter Custom Code - End */

    return (
        <StyledWrapper {...styles.signOutWrapper}>
            {includeAccountMenu && userName && !currentUserIsGuest && !isPunchOutSession /* Starter Custom Code */ && (
                /* Starter Custom Code - Start */
                <>
                    <Popover
                        {...styles.popover}
                        controlsId="accountMenu"
                        data-test-selector="header_accountMenu"
                        contentBodyProps={{
                            ...styles.popover?.contentBodyProps,
                            as: "div",
                            ref: elementRef,
                        }}
                        positionFunction={() => ({
                            position: "absolute",
                            right: 0,
                        })}
                        ref={popoverRef}
                        insideRefs={[elementRef]}
                        popoverTrigger={
                            <HeaderLink
                                iconSrc={icon?.src}
                                iconOffset={icon?.offset}
                                showIconOnly={showIconOnly}
                                // Store Removed - label
                                text={userDisplayName} // Store Custom Code
                                extendedStyles={styles.headerLink}
                                isDropdown
                                data-test-selector="header_signIn"
                            >
                                <AccountMessagesCount {...styles.accountMessagesCountStyles} />
                            </HeaderLink>
                        }
                    >
                        <GridContainer {...styles.popoverGridContainer}>
                            <GridItem {...styles.popoverMenuGridItem}>
                                <SideMenu
                                    {...styles.sideMenu}
                                    pageType={constants.pageType.myAccount}
                                    showRootPage
                                    showSignOut
                                    onClick={closePopover}
                                    links={menuItems}
                                />
                            </GridItem>
                            <GridItem {...styles.popoverInfoGridItem}>
                                <LoadingOverlay loading={isInfoLoading} {...styles.loadingOverlay}>
                                    {billTo || shipTo ? (
                                        <StyledWrapper {...styles.infoSection}>
                                            <GridContainer {...styles.infoGridContainer}>
                                                {billTo && (
                                                    <GridItem {...styles.infoGridItem}>
                                                        <Typography {...styles.infoSubtitle}>
                                                            {translate("Billing Address")}
                                                        </Typography>
                                                        <StyledWrapper {...styles.addressWrapper}>
                                                            <AddressInfoDisplay
                                                                {...billTo}
                                                                state={billTo.state?.abbreviation}
                                                                country={billTo.country?.abbreviation}
                                                                extendedStyles={styles.address}
                                                            />
                                                        </StyledWrapper>
                                                    </GridItem>
                                                )}
                                                {shipTo && (
                                                    <GridItem {...styles.infoGridItem}>
                                                        <Typography {...styles.infoSubtitle}>
                                                            {fulfillmentMethod === FulfillmentMethod.PickUp
                                                                ? translate("Recipient Address")
                                                                : translate("Shipping Address")}
                                                        </Typography>
                                                        <StyledWrapper {...styles.addressWrapper}>
                                                            <AddressInfoDisplay
                                                                {...shipTo}
                                                                state={shipTo.state?.abbreviation}
                                                                country={shipTo.country?.abbreviation}
                                                                extendedStyles={styles.address}
                                                            />
                                                        </StyledWrapper>
                                                    </GridItem>
                                                )}
                                            </GridContainer>
                                        </StyledWrapper>
                                    ) : null}
                                    {/* Store Custom Code - next line - isB2BCustomer */}
                                    {enableWarehousePickup && isB2BCustomer && (
                                        <StyledWrapper {...styles.infoSection}>
                                            <GridContainer {...styles.infoGridContainer}>
                                                <GridItem {...styles.infoGridItem}>
                                                    <Typography {...styles.infoSubtitle}>
                                                        {translate("Fulfillment Method")}
                                                    </Typography>
                                                    <RadioGroup
                                                        value={fulfillmentMethod}
                                                        onChangeHandler={handleChangeFulfillmentMethod}
                                                        {...styles.fulfillmentRadioGroup}
                                                    >
                                                        <Radio value={FulfillmentMethod.Ship}>
                                                            {translate("Ship")}
                                                        </Radio>
                                                        <Radio value={FulfillmentMethod.PickUp}>
                                                            {translate("Pick Up")}
                                                        </Radio>
                                                    </RadioGroup>
                                                </GridItem>
                                                <GridItem {...styles.infoGridItem}>
                                                    {fulfillmentMethod === FulfillmentMethod.PickUp && (
                                                        <>
                                                            <Typography {...styles.infoSubtitle}>
                                                                {translate("Pick Up Location")}
                                                            </Typography>
                                                            {pickUpWarehouse ? (
                                                                <StyledWrapper {...styles.addressWrapper}>
                                                                    <Typography {...styles.addressName}>
                                                                        {pickUpWarehouse.description ||
                                                                            pickUpWarehouse.name}
                                                                    </Typography>
                                                                    <AddressInfoDisplay
                                                                        {...pickUpWarehouse}
                                                                        extendedStyles={styles.address}
                                                                    />
                                                                </StyledWrapper>
                                                            ) : null}
                                                            <Link onClick={changeWarehouse} {...styles.addressLink}>
                                                                {translate("Change")}
                                                            </Link>
                                                        </>
                                                    )}
                                                </GridItem>
                                            </GridContainer>
                                        </StyledWrapper>
                                    )}
                                </LoadingOverlay>
                            </GridItem>
                        </GridContainer>
                    </Popover>
                    {isSignedIn && (
                        <FindLocationModal
                            modalIsOpen={isLocationModalOpen}
                            onWarehouseSelected={selectWarehouse}
                            onModalClose={closeLocationModal}
                            modalIsLoading={isLocationModalLoading}
                        />
                    )}
                </>
                /* Starter Custom Code - End */
            )}
            {!isPunchOutSession /* Starter Custom Code */ &&
                (!includeAccountMenu || !userName || (userName && currentUserIsGuest)) && (
                    /* Starter Custom Code - Start */
                    <HeaderLink
                        onClick={onSignInHandler}
                        href={!signInUrl ? "/MyAccount/SignIn" : signInUrl}
                        iconSrc={icon?.src}
                        iconOffset={icon?.offset}
                        showIconOnly={showIconOnly}
                        // Store Removed - label
                        text={translate("Login / Register")} // Store Custom Code
                        extendedStyles={styles.headerLink}
                        data-test-selector="header_signIn"
                    >
                        <AccountMessagesCount {...styles.accountMessagesCountStyles} />
                    </HeaderLink>
                    /* Starter Custom Code - End */
                )}
            {userName && !currentUserIsGuest && isPunchOutSession /* Starter Custom Code */ && (
                /* Starter Custom Code - Start */
                <HeaderLink
                    onClick={onSignOutHandler}
                    iconSrc={icon?.src}
                    iconOffset={icon?.offset}
                    showIconOnly={showIconOnly}
                    // Store Removed - label
                    text={translate("Cancel PunchOut")}
                    extendedStyles={styles.headerLink}
                    data-test-selector="headerSignOutLink"
                />
                /* Starter Custom Code - End */
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(HeaderSignIn))),
    definition: {
        displayName: "Header Sign In",
        icon: "arrow-right-to-bracket",
        fieldDefinitions: [
            {
                name: fields.visibilityState,
                displayName: "Settings",
                editorTemplate: "RadioButtonsField",
                options: [
                    {
                        displayName: "Show Icon and Label", // Starter Custom Code
                        value: "both",
                    },
                    // Starter Removed - Show Label
                    {
                        displayName: "Show Icon Only", // Starter Custom Code
                        value: "icon",
                    },
                ],
                defaultValue: "both",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.icon,
                displayName: "SignIn Icon",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "User",
                        value: "user", // Starter Custom Code
                    },
                ],
                defaultValue: "user", // Starter Custom Code
                fieldType: "General",
                sortOrder: 2,
                isRequired: true, // Starter Custom Code
            },
            {
                name: fields.includeAccountMenu,
                displayName: "Include My Account Menu",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
            // Starter Removed - fields.showPricingToggle
            // Starter Removed - fields.showInventoryToggle
        ],
        group: "Common",
    },
};

export default widgetModule;
